import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
export const CTA: React.FC = () => {
  return <section className="py-32 bg-mint" data-id="element-120">
      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center" data-id="element-121">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-122">
          <h2 className="font-display text-5xl md:text-6xl text-primary mb-6" data-id="element-123">
            Ready to close the loop?
          </h2>
          <p className="text-xl text-ink/70 mb-10 max-w-2xl mx-auto" data-id="element-124">
            Tell us what you're shipping and we'll show you how the loop would
            work for you. No slides, just a real conversation.
          </p>

          <form className="flex flex-col sm:flex-row gap-4 justify-center max-w-lg mx-auto" onSubmit={e => e.preventDefault()} data-id="element-125">
            <input type="email" placeholder="Enter your work email" className="flex-1 px-6 py-4 rounded-full border border-primary/15 bg-white focus:outline-none focus:border-leaf focus:ring-2 focus:ring-leaf/30 transition-all text-ink placeholder:text-muted shadow-glossy" required data-id="element-126" />
            <Button type="submit" size="lg" className="whitespace-nowrap" data-id="element-127">
              Request Demo
            </Button>
          </form>
          <p className="text-sm text-muted mt-4 font-mono" data-id="element-128">
            We'll get back to you within a day or two.
          </p>
        </motion.div>
      </div>
    </section>;
};